import { blogContent as longFormContent } from './blog-content';

export interface BlogPost {
  slug: string;
  kicker: string;
  title: string;
  excerpt: string;
  author: string;
  authorRole: string;
  date: string;
  readTime: string;
  hue: string;
  emoji: string;
  featured?: boolean;
}

export const blogPosts: BlogPost[] = [
  {
    slug: 'two-yes-rule',
    kicker: 'INTIMACY · FEATURED',
    title: 'The Two-Yes Rule: Why Mutual Consent Makes Intimacy Better',
    excerpt: 'What happens when both partners have to say yes before anything appears? A look at how the two-yes mechanic transforms couple communication.',
    author: 'Asha Kapoor',
    authorRole: 'CEO & Co-founder',
    date: 'Apr 24, 2026',
    readTime: '8 min read',
    hue: '#FF2E7E',
    emoji: '💕',
    featured: true,
  },
  {
    slug: '12-ways-to-reconnect',
    kicker: 'PLAYBOOK',
    title: '12 Ways to Reconnect When Life Gets in the Way',
    excerpt: 'Busy schedules don\'t have to mean a disconnected relationship. Here are twelve research-backed ways to stay close — even when you barely have time to breathe.',
    author: 'Dr. Lena Osei',
    authorRole: 'Relationship Therapist',
    date: 'Apr 18, 2026',
    readTime: '6 min read',
    hue: '#EC4899',
    emoji: '🔄',
  },
  {
    slug: 'science-of-play',
    kicker: 'RESEARCH',
    title: 'The Science of Play in Adult Relationships',
    excerpt: 'Why playfulness is the most underrated predictor of relationship satisfaction, according to the latest longitudinal research from the Gottman Institute.',
    author: 'Dr. Lena Osei',
    authorRole: 'Relationship Therapist',
    date: 'Apr 12, 2026',
    readTime: '10 min read',
    hue: '#a855f7',
    emoji: '🧪',
  },
  {
    slug: 'long-distance-intimacy',
    kicker: 'LONG DISTANCE',
    title: 'Staying Intimate Across Time Zones',
    excerpt: 'Practical strategies for couples navigating long-distance relationships without losing the spark. Tested by 50k+ LuvLust couples across 6,000+ miles.',
    author: 'Asha Kapoor',
    authorRole: 'CEO & Co-founder',
    date: 'Apr 6, 2026',
    readTime: '7 min read',
    hue: '#F472B6',
    emoji: '🌍',
  },
  {
    slug: 'dare-night-guide',
    kicker: 'PLAYBOOK',
    title: 'How to Plan the Perfect Dare Night',
    excerpt: 'A step-by-step guide to setting up a dare night that both partners will actually enjoy — from setting the mood to choosing the right heat level.',
    author: 'Asha Kapoor',
    authorRole: 'CEO & Co-founder',
    date: 'Mar 30, 2026',
    readTime: '5 min read',
    hue: '#DB2777',
    emoji: '🔥',
  },
  {
    slug: 'communication-styles',
    kicker: 'RESEARCH',
    title: 'Four Communication Styles That Make or Break Intimacy',
    excerpt: 'Understanding your communication style is the first step to deeper connection. Here\'s what the research says about the four patterns that predict relationship outcomes.',
    author: 'Dr. Lena Osei',
    authorRole: 'Relationship Therapist',
    date: 'Mar 24, 2026',
    readTime: '9 min read',
    hue: '#EC4899',
    emoji: '💬',
  },
  {
    slug: 'roleplay-beginners',
    kicker: 'PLAYBOOK',
    title: 'Roleplay for Beginners: It\'s Not What You Think',
    excerpt: 'Forget the clichés. Modern roleplay is about storytelling, vulnerability, and shared imagination — not costumes and scripts.',
    author: 'Asha Kapoor',
    authorRole: 'CEO & Co-founder',
    date: 'Mar 18, 2026',
    readTime: '6 min read',
    hue: '#FF2E7E',
    emoji: '🎭',
  },
  {
    slug: 'quiz-psychology',
    kicker: 'DESIGN NOTES',
    title: 'The Psychology Behind Our Couple Quiz',
    excerpt: 'How we designed a quiz that surfaces desires without judgment or pressure — and why the blind-reveal mechanic changes everything.',
    author: 'Asha Kapoor',
    authorRole: 'CEO & Co-founder',
    date: 'Mar 12, 2026',
    readTime: '8 min read',
    hue: '#a855f7',
    emoji: '🧠',
  },
  {
    slug: 'sex-positive-design',
    kicker: 'DESIGN NOTES',
    title: 'Designing a Sex-Positive App That Doesn\'t Feel Sleazy',
    excerpt: 'The design decisions behind making an intimacy app that feels safe, tasteful, and empowering — from color theory to copy tone.',
    author: 'Asha Kapoor',
    authorRole: 'CEO & Co-founder',
    date: 'Mar 6, 2026',
    readTime: '11 min read',
    hue: '#F472B6',
    emoji: '✨',
  },
];

export const gameModePosts: BlogPost[] = [
  {
    slug: 'how-dares-work',
    kicker: 'GAME MODE',
    title: 'How Dares Work: From Soft to Hardcore',
    excerpt: 'An inside look at LuvLust\'s dare system — four heat levels, 200+ challenges, and the psychology behind progressive intensity.',
    author: 'Asha Kapoor',
    authorRole: 'CEO & Co-founder',
    date: 'Feb 28, 2026',
    readTime: '7 min read',
    hue: '#FF2E7E',
    emoji: '🔥',
  },
  {
    slug: 'how-couple-quiz-works',
    kicker: 'GAME MODE',
    title: 'How the Couple Quiz Works: The Two-Yes Mechanic Explained',
    excerpt: 'Both partners answer privately. Only matched yeses appear. Here\'s the full breakdown of how our quiz creates safe vulnerability.',
    author: 'Asha Kapoor',
    authorRole: 'CEO & Co-founder',
    date: 'Feb 21, 2026',
    readTime: '6 min read',
    hue: '#a855f7',
    emoji: '💜',
  },
  {
    slug: 'how-stories-work',
    kicker: 'GAME MODE',
    title: 'How Roleplay Stories Work: Collaborative Storytelling for Couples',
    excerpt: 'Seven immersive scenarios designed for two. Read aloud, make choices together, and let the narrative carry you somewhere new.',
    author: 'Yuki Tanaka',
    authorRole: 'Head of Content',
    date: 'Feb 14, 2026',
    readTime: '8 min read',
    hue: '#EC4899',
    emoji: '📖',
  },
  {
    slug: 'how-nhie-works',
    kicker: 'GAME MODE',
    title: 'How Never Have I Ever Works: The Classic Game, Redesigned for Two',
    excerpt: 'Swipe-based gameplay, 300+ prompts, and a scoring system that turns confessions into connection. Here\'s how we reimagined NHIE.',
    author: 'Asha Kapoor',
    authorRole: 'CEO & Co-founder',
    date: 'Feb 7, 2026',
    readTime: '5 min read',
    hue: '#DB2777',
    emoji: '🃏',
  },
];

export const allPosts = [...blogPosts, ...gameModePosts];
export const featuredPost = blogPosts.find((p) => p.featured)!;
export const gridPosts = blogPosts.filter((p) => !p.featured);

export const blogContent: Record<string, { body: string }> = {
  ...longFormContent,
};
